import {getQuery, postQuery, putQuery, removeQuery} from "@/modules/common/utils";

const get = (params = {}) => {
  params.new_api = true
  return getQuery('/business/payments/v1/products', params)
}

const getAllProducts = async (onPageLoaded = null) => {
  let pageIndex = 1, perPage = 100;
  let productsFullList = [], products = (await get({page: pageIndex++, per_page: perPage})).data.products;
  productsFullList.push(...products.filter(p => p.display));

  while (products.length === perPage){
    if (typeof onPageLoaded === 'function') {
      onPageLoaded(productsFullList);
    }
    products = (await get({page: pageIndex++, per_page: perPage})).data.products;
    productsFullList = productsFullList.concat(products.filter(p => p.display));
  }

  if (typeof onPageLoaded === 'function') {
    onPageLoaded(productsFullList);
  }
  return productsFullList;
}

const create = (params = {}) => {
  params.new_api = true
  return postQuery('/business/payments/v1/products', params)
}

const createProductOrder = (params = {}) => {
  params.new_api = true
  return postQuery('/business/payments/v1/product_orders', params)
}

const edit  = (params = {}) => {
  params.new_api = true
  const productId = params.product.id
  delete params.product.id
  return putQuery(`/business/payments/v1/products/${productId}`, params)
}

const editProductOrder = (params = {}) => {
  params.new_api = true
  const productOrderId = params.product_order.id
  return putQuery(`/business/payments/v1/product_orders/${productOrderId}`, params)
}

const remove =  (productId, params = {}) => {
  params.new_api = true
  return removeQuery(`/business/payments/v1/products/${productId}`, params)
}

const show =  (productId, params = {}) => {
  params.new_api = true
  return getQuery(`/business/payments/v1/products/${productId}`, params)
}

export const productService = {
  get,
  create,
  edit,
  remove,
  show,
  createProductOrder,
  editProductOrder,
  getAllProducts,
}
